/**
 * 格式化时间函数
 * @param time:需要格式化的时间
 * @param format：需要格式化为哪种格式 默认输出为YYYY-MM-DD hh:mm:ss
*/
export const PublicFormatTime = (time, format = 'YY-MM-DD hh:mm:ss') => {
  const date = new Date(time)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const min = date.getMinutes()
  const sec = date.getSeconds()
  let preArr = Array.apply(null, Array(10)).map((el, i) => '0' + i)

  let newTime = format.replace(/YY/g, year)
    .replace(/MM/g, preArr[month] || month)
    .replace(/DD/g, preArr[day] || day)
    .replace(/hh/g, preArr[hour] || hour)
    .replace(/mm/g, preArr[min] || min)
    .replace(/ss/g, preArr[sec] || sec)
  return newTime
}
